import { useTranslation } from 'react-i18next'

import { BirdviewRowRelativeTime } from '../BirdviewRowRelativeTime'
import { DashboardListRow } from '../DashboardListRow'

import { getBirdviewCommunicationRowKind } from './BirdviewCommunicationRow.utils'

function BirdviewCommunicationRow({ item, onOpen }) {
  const { t } = useTranslation()

  const { Icon, emptyTitleKey } = getBirdviewCommunicationRowKind(item.kind)

  function handleOpen(event) {
    onOpen({ event, item })
  }

  return (
    <DashboardListRow
      Icon={Icon}
      Meta={BirdviewRowRelativeTime}
      isUnread={item.unread}
      metaProps={{ date: item.date }}
      subtitle={item.subtitle}
      title={item.title || t(emptyTitleKey)}
      onAction={handleOpen}
      onMouseDownTitle={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewCommunicationRow
